/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-silo.scss';

/* eslint-disable import/no-unresolved, import/default */

import editSiloTemplate from './edit-silo.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editSilo', [])
    .directive('agEditSilo', EditSilo)
    .name;

/*@ngInject*/
function EditSilo() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EditSiloController,
        controllerAs: 'vm',
        templateUrl: editSiloTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditSiloController($rootScope, $scope, $timeout, $translate, agTypes, userService, siloService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.silo = null;

    vm.copySilo = copySilo;
    vm.moveSilo = moveSilo;
    vm.gotoSiloDetails = gotoSiloDetails;
    vm.save = save;
    vm.cancel = cancel;

    var defaultTitle = $translate.instant(agTypes.assetTypeTranslatePrefix + '.' + agTypes.assetType.silo) + '';

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
        }
    });

    $scope.$watch(function() { return vm.silo ? vm.silo.name : defaultTitle; }, function(title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('siloSelected', function(event, siloId) {
        if (vm.showData) {
            reload(siloId);
        }
    });

    function reload(siloId) {
        if (!vm.silo || !angular.equals(vm.silo.id, siloId)) {
            vm.loading = true;
            vm.origSilo = null;
            vm.silo = null;
            if (siloId) {
                siloService.getSilo(siloId).then(
                    function success(silo) {
                        vm.origSilo = silo;
                        vm.silo = angular.copy(silo);
                        vm.loading = false;
                        resetFormState();
                    }
                );
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function copySilo($event) {
        siloService.copySiloDialog($event, vm.origSilo).then(
            function() {
                $rootScope.$broadcast('siloCopied');
            }
        );
    }

    function moveSilo($event) {
        siloService.moveSiloDialog($event, vm.origSilo, vm.ctx.stateController.getStateParams().entityId).then(
            function() {
                reload();
                $rootScope.$broadcast('siloMoved');
            }
        );
    }

    function gotoSiloDetails($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: vm.silo.id
        };
        vm.ctx.stateController.openState(agTypes.adminState.silo, params);
    }

    function cancel() {
        vm.silo = angular.copy(vm.origSilo);
        resetFormState();
    }

    function save() {
        siloService.saveSilo(vm.silo).then(function success(silo) {
            vm.origSilo = silo;
            vm.silo = angular.copy(silo);
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
            $rootScope.$broadcast('siloUpdated', vm.origSilo);
        });
    }

}

